/* eslint no-prototype-builtins: "off" */
import React, { useState } from 'react';
import Container from './Container';
import Section from './Section';
import DownloadArrow from '../icons/download-arrow.svg';
import DownloadDoc from '../icons/download.svg';
import style from '../cssmodules/downloads.module.scss';
import btn from '../cssmodules/button.module.scss';

function Downloads({ title, downloads, modifyer }) {
  const initialDownloads = downloads.filter(
    download => !download.hasOwnProperty('archive') || !download.archive
  );
  const archiveDownloads = downloads.filter(download => download.archive);
  const [liveDownloads, setLiveDownloads] = useState(initialDownloads);
  const [showArchive, setShowArchive] = useState(false);

  console.log('initial', initialDownloads);

  const handleShowArchive = () => {
    setLiveDownloads(downloads);
    setShowArchive(true);
  };

  return (
    <Section modifyer={modifyer}>
      <Container>
        <h2 className={`heading2 ${style.title}`}>{title}</h2>
        <div className={style.downloads}>
          {liveDownloads.map(download => (
            <div className={style.download}>
              <DownloadDoc />
              <h3 className={`heading3 ${style.downloadTitle}`}>
                {download.documentTitle}
              </h3>
              <a
                className={style.downloadLink}
                href={download.documentFile.publicURL}
                target="_blank"
                rel="noopener noreferrer"
              >
                <DownloadArrow />
                <span>download</span>
              </a>
            </div>
          ))}
        </div>
        {archiveDownloads.length > 0 && !showArchive && (
          <div className={style.btnWrapper}>
            <button
              onClick={handleShowArchive}
              type="button"
              className={`${btn.btn} ${btn.btnVioletRedOnWhite}`}
            >
              See all {title}
            </button>
          </div>
        )}
      </Container>
    </Section>
  );
}

Downloads.defaultProps = {
  modifyer: false,
};

export default Downloads;
